subscribe(PUB_SUB_EVENTS.mapsApiLoad, () => {
  if (!customElements.get('store-locator-details')) {
    class StoreLocatorDetails extends HTMLElement {
      constructor() {
        super();
        this.latitude = parseFloat(this.getAttribute('data-latitude'));
        this.longitude = parseFloat(this.getAttribute('data-longitude'));
        this.storeType = this.getAttribute('data-storetype');
        this.mapStyle = this.getAttribute('data-map-styles') && JSON.parse(this.getAttribute('data-map-styles'));
        this.mapZoom = parseInt(this.getAttribute('data-zoom'));
      }
      connectedCallback() {
        this.innerHTML = `<div id="store-map"></div>`;
        this.initMap();
      }

      initMap() {
        const myLatLng = { lat: this.latitude, lng: this.longitude };
        const map = new google.maps.Map(this.querySelector('#store-map'), {
          zoom: this.mapZoom,
          center: myLatLng,
          disableDefaultUI: true,
          zoomControl: true,
          styles: this.mapStyle ?? [],
        });

        if (!!window?.storeLocatorStrings?.pins[this.storeType]) {
          const marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: {
              url: window.storeLocatorStrings.pins[this.storeType],
              scaledSize: new google.maps.Size(46, 58),
            },
          });
        } else {
          const marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
          });
        }
      }
    }
    customElements.define('store-locator-details', StoreLocatorDetails);
  }
});
